import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import clsx from 'clsx'

import FlightDealsBanner from './flightDealsBanner'
import ContactDetails from './contactDetails'
import useAlertFormHandle from '../../hooks/useAlertFormHandle'
import validate from '../../utils/validateContactForm'
import {
  CALL_FORM_ERROR,
  CALL_FORM_SUCCESS,
  MODAL_CALL_FORM_SUCCESS
} from '../../constants'
import useDebounce from '../../hooks/useDebounce'
import { SEND_CALLBACK_REQUEST } from '../../routes'
import ErrorIcon from '../../images/error.svg'

const errorStyle = {
  main: {
    position: 'absolute',
    top: '38px',
    right: '20px'
  },
  tooltip: { right: '10px', height: '24px', padding: '0 8px' }
}

const Input = ({ label, error, ...rest }) => {
  return (
    <>
      <label htmlFor='name'>{label}</label>
      <input
        className={clsx('form-control-call', error && 'field-error-focus')}
        {...rest}
      />
      {error && (
        <span>
          <span style={errorStyle.main}>
            <img src={ErrorIcon} alt='' style={{ height: '20px' }} />
          </span>
          <span className='field-error' style={errorStyle.tooltip}>
            {error}
          </span>
        </span>
      )}
    </>
  )
}

const ContactForm = ({ mountedInErrorPopup, setShowCallUsOption }) => {
  const [message, setMessage] = useState(null)
  const [isFormVisible, setIsFormVisible] = useState(mountedInErrorPopup)
  const [error, setError] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const bottomRef = useRef(null)
  const messageRef = useRef(null)

  const alertForm = () => {
    setIsSubmitting(true)
    const formData = new FormData()
    formData.append('namet', inputs.name)
    formData.append('phone', inputs.phone)
    formData.append('email', inputs.email)
    formData.append('type', 'landing')

    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    }

    axios
      .post(SEND_CALLBACK_REQUEST, formData, headers)
      .then(() => {
        setMessage(
          mountedInErrorPopup ? MODAL_CALL_FORM_SUCCESS : CALL_FORM_SUCCESS
        )
        setError(false)
        setInputs({ name: '', email: '', phone: '' })
        setIsSubmitting(false)
        if (mountedInErrorPopup) setShowCallUsOption(true)
        else hideMessage()
      })
      .catch(err => {
        console.log(err)
        setMessage(CALL_FORM_ERROR)
        setError(true)
        setIsSubmitting(false)
        hideMessage()
      })
  }

  const hideMessage = useDebounce(() => {
    setMessage(null)
  }, 3000)

  const handleFormVisibility = () => {
    setIsFormVisible(state => !state)
  }

  const { inputs, setInputs, handleInputChange, handleSubmit, errors } =
    useAlertFormHandle(alertForm, validate)

  useEffect(() => {
    if (message) {
      messageRef.current &&
        messageRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        })
    }
  }, [message])

  useEffect(() => {
    if (isFormVisible && !mountedInErrorPopup) {
      bottomRef.current.scrollIntoView({
        block: 'end',
        behavior: 'smooth'
      })
    }
  }, [isFormVisible, mountedInErrorPopup])

  return (
    <div
      className='sa-call-now-section2'
      style={{
        marginTop: mountedInErrorPopup ? 0 : '',
        paddingTop: mountedInErrorPopup ? 0 : '',
        height: 'max-content'
      }}
    >
      {!mountedInErrorPopup && (
        <FlightDealsBanner
          isFormVisible={isFormVisible}
          handleFormVisibility={handleFormVisibility}
        />
      )}
      <div
        className='mob_get_form'
        id='mob_getcall_form'
        style={{ display: isFormVisible ? 'block' : 'none' }}
      >
        {mountedInErrorPopup && message && !error ? (
          <div>
            <div
              className='call_form_success_msg'
              dangerouslySetInnerHTML={{ __html: message }}
            />
            <div className='sa-or' style={{ margin: '10px auto 0' }}>
              or
            </div>
            <ContactDetails mountedInErrorPopup={mountedInErrorPopup} />
          </div>
        ) : (
          <div
            className='sa-phone-bk-form filFrm'
            style={{
              marginTop: mountedInErrorPopup ? '0' : '',
              borderTop: mountedInErrorPopup ? 'none' : ''
            }}
          >
            <div className='pdPhn'>
              <form onSubmit={handleSubmit} noValidate>
                <div className='row filFrmAlt'>
                  <div className='col-sm-6 col-xs-12'>
                    <Input
                      type='text'
                      name='name'
                      label='Name'
                      placeholder='Your Name'
                      value={inputs.name}
                      onChange={handleInputChange}
                      error={errors.name}
                    />
                  </div>
                  <div className='col-sm-6 col-xs-12 tpMrLb'>
                    <Input
                      type='email'
                      name='email'
                      label='Email'
                      placeholder='Your email address'
                      value={inputs.email}
                      onChange={handleInputChange}
                      error={errors.email}
                    />
                  </div>
                </div>
                <div className='row filFrmAlt tpSesFrm'>
                  <div className='col-sm-6 col-xs-12'>
                    <Input
                      type='tel'
                      name='phone'
                      label='Phone Number'
                      placeholder='+1-213-225-9813'
                      value={inputs.phone}
                      onChange={handleInputChange}
                      error={errors.phone}
                    />
                  </div>

                  <div className='col-sm-6 col-xs-12 rqstBtnMr'>
                    <button
                      type='submit'
                      className='btn btn-rqust'
                      disabled={isSubmitting}
                    >
                      <span className={isSubmitting ? 'loading' : ''}>
                        {isSubmitting ? 'Submitting' : 'Claim Discount'}
                      </span>
                    </button>
                  </div>
                </div>
              </form>

              {message && (
                <div
                  className={clsx(
                    'alert',
                    error ? 'alert-danger' : 'alert-success'
                  )}
                  role='alert'
                  style={{
                    margin: '39px 0 0',
                    fontSize: '20px'
                  }}
                  ref={messageRef}
                  dangerouslySetInnerHTML={{ __html: message }}
                />
              )}
            </div>
          </div>
        )}
      </div>
      {!mountedInErrorPopup && (
        <div className='call_form_bottom' ref={bottomRef}></div>
      )}
    </div>
  )
}

export default ContactForm
